// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"caad0ebf","174":"7049a28a","320":"caad0ebf","376":"d42c486d","526":"1ac15fe1","579":"e0bcce09","833":"1ac15fe1"}[chunkId] + ".chunk.css";
};